export function isBindingContextLoaded(loadedContexts, context) {
    const key = "object" == typeof context && null !== context || "function" == typeof context ? context : loadedContexts;
    return !!loadedContexts.has(key) || (loadedContexts.add(key), !1);
}
//# sourceMappingURL=module-guard.js.map